__webpack_require__.p = "/publishPivot/";